module.exports = __webpack_public_path__ + "static/schiavello-furniture-1bc0aab831ba702f26f59b2a01eab5e1.jpg";